var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "date-fns", "@date-fns/upgrade/v2"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("date-fns"), require("@date-fns/upgrade/v2"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.dateFns, global.v2);
    global.getAvailabilityLabel = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _dateFns, _v) {
  "use strict";

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  var STICKER_TYPES_ORDER = ['TV_LIVE', 'LIVE', 'SOON'];

  var parseDate = function parseDate(date) {
    return !date || date instanceof Date ? (0, _v.legacyParse)(date) : (0, _dateFns.parseISO)(date);
  };

  var getAvailabilityLabel = function getAvailabilityLabel(translate) {
    return function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          availability = _ref.availability,
          stickers = _ref.stickers;

      if (!availability) {
        return null;
      }

      var start = availability.start,
          end = availability.end,
          type = availability.type;

      if ((0, _dateFns.isPast)(parseDate(start)) && (0, _dateFns.isFuture)(parseDate(end)) && stickers) {
        var sticker = stickers.filter(function (x) {
          return x.label;
        }).reduce(function (acc, currentSticker) {
          var accCodeIndex = STICKER_TYPES_ORDER.indexOf(acc.code);
          var currentStickerCodeIndex = STICKER_TYPES_ORDER.indexOf(currentSticker.code);

          if (accCodeIndex === -1) {
            return currentSticker;
          }

          if (accCodeIndex < currentStickerCodeIndex) {
            return acc;
          }

          return currentSticker;
        }, {});

        if (STICKER_TYPES_ORDER.indexOf(sticker.code) !== -1) {
          return sticker.label;
        }
      }

      if (!(0, _dateFns.isFuture)(parseDate(start))) {
        return null;
      }

      var translationKey = {
        VOD: 'teasers.availability.available_on',
        LIVESTREAM_TV: 'teasers.availability.live_on',
        LIVESTREAM_WEB: 'teasers.availability.livestream_on',
        BROADCAST: 'teasers.availability.broadcast_on'
      }[type] || null;

      if ((0, _dateFns.isToday)(parseDate(start))) {
        translationKey += '_today';
      }

      return translate(translationKey, {
        date: (0, _dateFns.format)(parseDate(start), translate('teasers.availability.formats.date')),
        hour: (0, _dateFns.format)(parseDate(start), translate('teasers.availability.formats.hour'))
      });
    };
  };

  var _default = getAvailabilityLabel;
  _exports.default = _default;
});